import { FormGroup } from '@angular/forms';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formControl'
})
export class FormControlGetterPipe implements PipeTransform {

  transform(formControllName: string, form: FormGroup): any {
    const formControll = form.get(formControllName);
    return formControll;
  }

}

export function GetFormControl(formControllName: string, form: FormGroup) {
  const formControll = form.get(formControllName);
  return formControll;
}
